/* eslint-disable react-doctor/only-export-components */
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { DocsArticlePage } from "@/components/docs/docs-article-page";
import {
	DocsCenterLayout,
	DocsCenterSidebar,
} from "@/components/docs/docs-center-layout";
import {
	getKnowledgeBaseDisplayTitle,
	getKnowledgeBaseNavSections,
	getKnowledgeBasePost,
} from "@/lib/docs-content";
import { docsKnowledgeBaseLink } from "@/lib/docs-paths";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_docs/docs/knowledge-base/$slug")({
	beforeLoad: () => redirectIfModuleDisabled("knowledge_base", "/"),
	component: KnowledgeBaseArticleRoute,
});

function KnowledgeBaseArticleRoute() {
	const { slug } = Route.useParams();
	const post = getKnowledgeBasePost(slug);
	const sections = getKnowledgeBaseNavSections();

	if (!post) {
		return <Navigate to="/docs/knowledge-base" replace />;
	}

	return (
		<DocsCenterLayout
			mobileNavTitle="Knowledge base"
			sidebar={
				<DocsCenterSidebar
					title="Knowledge base"
					description="Short reference articles"
					sections={sections}
					activeSlug={slug}
					linkForSlug={docsKnowledgeBaseLink}
				/>
			}
		>
			<DocsArticlePage
				title={getKnowledgeBaseDisplayTitle(post)}
				summary={post.summary}
				mdxModule={post.mdxModule}
				tableOfContents={post.tableOfContents}
			/>
		</DocsCenterLayout>
	);
}
